function applySwatchBg(swatch) {
  if (!swatch) return

  const bg = getComputedStyle(swatch).backgroundImage
  if (!bg || bg === 'none') return


  document.documentElement.style.setProperty(
    '--product-bg',
  bg
  )
}


/* ▼ 初期表示時 */
document.addEventListener('DOMContentLoaded', function () {
const checkedInput = document.querySelector(
'.variant-input input[type="radio"][name="Color"]:checked'
)

if (!checkedInput) return


const swatch = checkedInput
.closest('.variant-input')
?.querySelector('.variant__button-label.color-swatch')


applySwatchBg(swatch)
})


/* ▼ クリック時 */
document.addEventListener('click', function (e) {
const swatch = e.target.closest('.variant__button-label.color-swatch')
if (!swatch) return


applySwatchBg(swatch)
})